<template>
  <div class="layerPop" id="popPdtCode" v-if="isVisible">
    <div class="popWrap">
      <div class="popBox popType1">
        <div class="popHead">
          <p class="popTit">품목코드</p>
        </div>
        <div class="popCon">
          <div class="conStyle1">
            <p class="tit mgt0">품목의 대, 중, 소분류를 선택하세요.</p>
          </div>

          <div class="tabStyle1">
            <table>
              <caption>
                품목의 대, 중, 소분류를 선택
              </caption>
              <colgroup>
                <col width="140" />
                <col width="*" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">대분류</th>
                  <td>
                    <div class="inpSlt">
                      <button type="button" class="sltBtn" title="조건 선택">
                        <span>{{ dataLv1Title }}</span>
                      </button>
                      <ul>
                        <li v-for="(d, index) in dataLv1List" :key="index">
                          <button
                            type="button"
                            class="sltOpt"
                            title="선택"
                            @click="onClickLv1Item(d, index)"
                          >
                            <span>{{ d.itmNm }}</span>
                          </button>
                        </li>
                        <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                      </ul>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">중분류</th>
                  <td>
                    <div class="inpSlt">
                      <button type="button" class="sltBtn" title="조건 선택">
                        <span>{{ dataLv2Title }}</span>
                      </button>
                      <ul>
                        <li v-for="(d, index) in dataLv2List" :key="index">
                          <button
                            type="button"
                            class="sltOpt"
                            title="선택"
                            @click="onClickLv2Item(d)"
                          >
                            <span>{{ d.itmNm }}</span>
                          </button>
                        </li>
                        <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                      </ul>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">소분류</th>
                  <td>
                    <div class="inpSlt">
                      <button type="button" class="sltBtn" title="조건 선택">
                        <span>{{ dataLv3Title }}</span>
                      </button>
                      <ul>
                        <li v-for="(d, index) in dataLv3List" :key="index">
                          <button
                            type="button"
                            class="sltOpt"
                            title="선택"
                            @click="selectLv3Item(d, index)"
                          >
                            <span>{{ d.itmNm }}</span>
                          </button>
                        </li>
                        <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="popBtn">
          <a class="btnType sizeS colorB" @click="send(totalresult)"
            ><span>확인</span></a
          >
        </div>
        <slot></slot>
        <button type="button" class="popClose" @click="close()">
          <span class="hide">닫기</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineEmits,
  reactive,
  inject,
  defineExpose,
  onUnmounted,
  onMounted,
} from "vue";

const isVisible = ref(false);
const axios = inject("axios");

let totalresult = ref([]);
let dataLv1List = ref(null);
let dataLv2List = ref(null);
let dataLv3List = ref(null);

let dataLv1Title = ref(null);
let dataLv2Title = ref(null);
let dataLv3Title = ref(null);

const emits = defineEmits(["update:data", "close"]);

const open = () => {
  isVisible.value = true;
};

//확인 버튼
const send = (totalresult) => {
  const data = {
    hgrkItmCd: totalresult.hgrkItmCd,
    itmCd: totalresult.itmCd,
    itmCdDtl: totalresult.itmCdDtl,
    itmLv: totalresult.itmLv,
    itmNm: totalresult.itmNm,
    untPdCd: totalresult.untPdCd,
  };
  if (data.itmCd == undefined) {
    alert("소분류를 선택하세요.");
  } else {
    isVisible.value = false;
    emits("update:data", data);
  }
};

const close = () => {
  isVisible.value = false;
  emits("close");
};

//소분류 값 선택
const selectLv3Item = async (d) => {
  let param = {
    hgrkItmCd: d.hgrkItmCd,
    itmCd: d.itmCd,
    itmCdDtl: d.itmCdDtl,
    itmLv: d.itmLv,
    itmNm: d.itmNm,
    untPdCd: d.untPdCd,
  };

  totalresult.value = param;

  dataLv3Title.value = d.itmNm;
  console.log(totalresult.value);
};

//중분류 값 선택시 소분류 값
const onClickLv2Item = async (d) => {
  let param = {
    hgrkItmCd: d.hgrkItmCd,
    itmCd: d.itmCd,
    itmCdDtl: d.itmCdDtl,
    itmLv: "3",
    itmNm: d.itmNm,
    untPdCd: "2100A",
  };
  let Lv3result = await axios.transaction("FNGCTNFO0003", param);

  let row = Lv3result.body.row;

  if (_.isObject(Lv3result.body.row) && !_.isArray(Lv3result.body.row)) {
    row = [];
    row.push(Lv3result.body.row);
  }

  dataLv3List.value = row;
  dataLv2Title.value = d.itmNm;
};

//대분류 값 선택시 중분류 값
const onClickLv1Item = async (d) => {
  let param = {
    hgrkItmCd: d.hgrkItmCd,
    itmCd: d.itmCd,
    itmCdDtl: d.itmCdDtl,
    itmLv: "2",
    itmNm: d.itmNm,
    untPdCd: "2100A",
  };

  let Lv2result = await axios.transaction("FNGCTNFO0003", param);

  let row = Lv2result.body.row;

  if (_.isObject(Lv2result.body.row) && !_.isArray(Lv2result.body.row)) {
    row = [];
    row.push(Lv2result.body.row);
  }

  dataLv2List.value = row;
  dataLv3List.value = [];

  dataLv1Title.value = d.itmNm;
  dataLv2Title.value = "";
  dataLv3Title.value = "";
};

//품목코드 팝업시 대분류 값
async function init() {
  let param = {
    hgrkItmCd: "",
    itmCd: "",
    itmCdDtl: "",
    itmLv: "1",
    itmNm: "",
    untPdCd: "2100A",
  };

  let Lv1result = await axios.transaction("FNGCTNFO0003", param);
  dataLv1List.value = Lv1result.body.row;
  console.log(dataLv1List.value);
}

init();

defineExpose({ open, close });
</script>
